import { Component } from '@angular/core';
import {Notificacao} from "../../models/notificacao";
import {Token} from "../../../modules/auth/models/token";
import {AuthService} from "../../../modules/auth/services/auth-service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {NotificacaoService} from "../../services/notificacao.service";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    standalone: false
})
export class HeaderComponent {
  notificacoes: Notificacao[] = [];
  token: Token | undefined;
  showNotificacao = false;
  showInfoUsuarios = false;

  constructor(private tokenService: AuthService,
              private notificacaoService: NotificacaoService,
              private toastr: ToastrService,
              private titleService: Title) {
    this.token = this.tokenService.AccessToken;
    this.notificacaoService.buscarPorUsuario().subscribe(resultado =>{
      if(resultado.sucesso)
        this.notificacoes = resultado.dados;
    });
  }

  logoff(){
    Swal.fire({
      title: 'Deseja realmente sair?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#4973cf',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.value){
        this.tokenService.logoff();
        this.toastr.warning("Volte sempre!");
      }
    });
  }

  exibirNotificacoes(){
    this.showNotificacao = true;
  }

  sairNotificacao(){
    this.showNotificacao = false;
  }

  exibirInfoUsuario(){
    this.showInfoUsuarios = true;
  }

  sairInfoUsuario(){
    this.showInfoUsuarios = false;
  }
}
